import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map, List } from 'immutable';

import * as configActions from 'modules/config';
import * as shareActions from 'modules/share';
import * as userActions from 'modules/user';

import { ServiceShare, MyPageTitle, MyPageTemplate } from 'components';

class CtServiceShare extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      saveStatus: 0
    };
  }

  componentDidMount() {
    this.getServiceShareInfo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.needReload && nextProps.needReload !== this.props.needReload) {
      this.getServiceShareInfo();
    }
  }

  getServiceShareInfo = async () => {
    const { ShareActions } = this.props;

    try {
      await ShareActions.getShare();
    } catch (e) {
      console.log(e);
    }
  };

  setLastServiceByAccessTime = async (e, checked) => {
    const { ConfigActions, UserActions, lastServiceByAccessTime } = this.props;

    try {
      await ConfigActions.updateServiceConfig({
        parameter: 'lastServiceByAccessTime',
        nowValue: checked ? 1 : 0
      });

      UserActions.changeUser({
        name: 'lastServiceByAccessTime',
        value: checked ? 1 : 0
      });

      this.setState({ saveStatus: 1 });
    } catch (e) {
      console.log(e);
      this.setState({ saveStatus: 2 });
    }
  };

  handleDismissSaveResult = data => {
    this.setState({ saveStatus: 0 });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { saveStatus } = this.state;
    const { isAuth, shareInfo, myInfo } = this.props;
    const { setLastServiceByAccessTime, handleDismissSaveResult } = this;

    let respData = [];
    if (shareInfo && Map.isMap(shareInfo) && shareInfo.get('result') === 1) {
      respData = shareInfo.toJS().success;
    }

    return (
      <MyPageTemplate className="service-share">
        <MyPageTitle title={defineMessages(formatMessage({ id: 'CtServiceShare_1', defaultMessage: '서비스 공유' }))} />
        <ServiceShare
          isAuth={isAuth}
          shareInfo={respData}
          myInfo={myInfo}
          setLastServiceByAccessTime={setLastServiceByAccessTime}
          handleDismissSaveResult={handleDismissSaveResult}
          saveStatus={saveStatus}
        />
      </MyPageTemplate>
    );
  }
}

CtServiceShare.propTypes = {};
CtServiceShare.defaultProps = {};

const mapStateToProps = state => {
  return {
    shareInfo: state.share.get('data'),
    needReload: state.share.get('needReload'),
    isAuth: state.user.get('isAuth'),
    myInfo: state.user.get('user'),
    lastServiceByAccessTime: state.user.get('user').lastServiceByAccessTime
  };
};

const mapDispatchToProps = dispatch => ({
  ConfigActions: bindActionCreators(configActions, dispatch),
  ShareActions: bindActionCreators(shareActions, dispatch),
  UserActions: bindActionCreators(userActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtServiceShare));



// WEBPACK FOOTER //
// ./src/script/containers/share/CtServiceShare.js